import { c as _c } from "react/compiler-runtime";
import { type TransitionEvent } from 'react';
import { ResponsiveImage } from '@/app/components/media/app-image';
import { SPARTAN_PRODUCT_HERO_DESKTOP_COMPOSITION_MEDIA, SPARTAN_PRODUCT_HERO_DESKTOP_IMAGE_WIDTHS, SPARTAN_PRODUCT_HERO_MOBILE_COMPOSITION_MEDIA } from '@/app/lcv/components/sections/spartan/products/hero-banner/constants';
import type { SpartanProductHeroBannerParallaxCarProps } from '@/app/lcv/components/sections/spartan/products/hero-banner/media/parallax-scene/car/types';
import styles from '@/app/lcv/components/sections/spartan/products/hero-banner/media/parallax-scene/layout.module.css';
import { SPARTAN_PRODUCT_HERO_BANNER_TRACKING } from '@/app/lcv/components/sections/spartan/products/hero-banner/tracking';
import { getSpartanProductHeroParallaxStyle } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/parallax-style';
import { getSpartanProductHeroBannerCarLayoutStyle, getSpartanProductHeroBannerParallaxMediaSizes } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/scene-layout';
import { getSpartanParallaxProps } from '@/app/lcv/components/sections/spartan/products/shared/product-parallax-scroll';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { safeCall } from '@/app/utils/safeCall';
export const SpartanProductHeroBannerParallaxCar = t0 => {
  const $ = _c(46);
  const {
    media,
    scene,
    scrollSpeed,
    onLoad,
    imageRef,
    onError,
    isEntranceRevealEnabled: t1,
    isEntranceReady: t2,
    isEntranceSettled: t3,
    onEntranceSettled,
    isLcp: t4
  } = t0;
  const isEntranceRevealEnabled = t1 === undefined ? false : t1;
  const isEntranceReady = t2 === undefined ? false : t2;
  const isEntranceSettled = t3 === undefined ? false : t3;
  const isLcp = t4 === undefined ? false : t4;
  let t5;
  if ($[0] !== media || $[1] !== scene) {
    t5 = getSpartanProductHeroBannerParallaxMediaSizes(media, scene);
    $[0] = media;
    $[1] = scene;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const sizes = t5;
  let t6;
  if ($[3] !== media || $[4] !== scene) {
    t6 = getSpartanProductHeroBannerCarLayoutStyle(media, scene);
    $[3] = media;
    $[4] = scene;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== scrollSpeed) {
    t7 = getSpartanProductHeroParallaxStyle(scrollSpeed);
    $[6] = scrollSpeed;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = {
      ...t6,
      ...t7
    };
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== scrollSpeed) {
    t9 = getSpartanParallaxProps(scrollSpeed);
    $[11] = scrollSpeed;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = createDataAttributes({
      test: SPARTAN_PRODUCT_HERO_BANNER_TRACKING.parallaxCar
    });
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = isEntranceRevealEnabled && isEntranceReady;
  let t12;
  if ($[14] !== isEntranceRevealEnabled || $[15] !== isEntranceSettled || $[16] !== t11) {
    t12 = cn(styles.carMedia, {
      [styles.carReveal]: isEntranceRevealEnabled,
      [styles.carRevealReady]: t11,
      [styles.entranceMotionSettled]: isEntranceSettled
    });
    $[14] = isEntranceRevealEnabled;
    $[15] = isEntranceSettled;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== onEntranceSettled) {
    t13 = event => {
      if (event.target !== event.currentTarget || event.propertyName !== "transform") {
        return;
      }
      safeCall(onEntranceSettled);
    };
    $[18] = onEntranceSettled;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [1080, 1280, 1440, 1680, 1920];
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      q: 85
    };
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== media.mobile.src || $[23] !== sizes) {
    t16 = {
      src: media.mobile.src,
      sizes,
      widths: t14,
      media: SPARTAN_PRODUCT_HERO_MOBILE_COMPOSITION_MEDIA,
      params: t15
    };
    $[22] = media.mobile.src;
    $[23] = sizes;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      q: 85
    };
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== media.desktop.src || $[27] !== sizes) {
    t18 = {
      src: media.desktop.src,
      sizes,
      widths: SPARTAN_PRODUCT_HERO_DESKTOP_IMAGE_WIDTHS,
      media: SPARTAN_PRODUCT_HERO_DESKTOP_COMPOSITION_MEDIA,
      params: t17
    };
    $[26] = media.desktop.src;
    $[27] = sizes;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  const t19 = isLcp ? "high" : undefined;
  const t20 = isLcp ? undefined : "eager";
  let t21;
  if ($[29] !== imageRef || $[30] !== isLcp || $[31] !== onError || $[32] !== onLoad || $[33] !== t16 || $[34] !== t18 || $[35] !== t19 || $[36] !== t20) {
    t21 = <ResponsiveImage mobileSrc={t16} desktopSrc={t18} alt="" fill={true} objectFit="contain" objectPosition="bottom" preload={isLcp} fetchPriority={t19} loading={t20} fade={false} testId={SPARTAN_PRODUCT_HERO_BANNER_TRACKING.car} imgRef={imageRef} onLoad={onLoad} onError={onError} />;
    $[29] = imageRef;
    $[30] = isLcp;
    $[31] = onError;
    $[32] = onLoad;
    $[33] = t16;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t12 || $[39] !== t13 || $[40] !== t21) {
    t22 = <div className={t12} onTransitionEnd={t13}>{t21}</div>;
    $[38] = t12;
    $[39] = t13;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t22 || $[43] !== t8 || $[44] !== t9) {
    t23 = <div aria-hidden="true" className={styles.car} style={t8} {...t9} {...t10}>{t22}</div>;
    $[42] = t22;
    $[43] = t8;
    $[44] = t9;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  return t23;
};